import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import AppRoutes from "./routes/AppRoutes";
import ErrorBoundary from "./utils/errorBoundary";
import AuthWrapper from "./components/wrappers/AuthWrapper";
import {
	useScreenWidth,
} from "./reusable/common";

const App: React.FC = () => {
	const isSmallScreen = useScreenWidth();

	// Fetch query parameters from URL
	const queryParams = new URLSearchParams(window.location.search);
	const primaryColorQuery = queryParams.get("primaryColor")
		? `#${queryParams.get("primaryColor")}`
		: null;
	const secondaryColorQuery = queryParams.get("secondaryColor")
		? `#${queryParams.get("secondaryColor")}`
		: null;
	const appFontQuery = queryParams.get("appFont");

	useEffect(() => {
		// Set colors with precedence for query parameters
		document.documentElement.style.setProperty(
			"--primary-color",
			primaryColorQuery || "#002E6E"
		);
		document.documentElement.style.setProperty(
			"--secondary-color",
			secondaryColorQuery || "#EFF2FA"
		);

		const font = `'${appFontQuery || "Figtree"}', sans-serif`;
		document.documentElement.style.setProperty("--font-family", font);

	}, [primaryColorQuery, secondaryColorQuery]);

	return (
		<ErrorBoundary>
			<ToastContainer />

			<div className="main-container h-100">
				<div className="right-panel h-100">
					{isSmallScreen ? (
						<div className="phone-container font h-100">
							<AuthWrapper>
								<AppRoutes />
							</AuthWrapper>
						</div>
					) : (
						<div className="desktop-container font h-100">
							<AuthWrapper>
								<AppRoutes desktop={true} />
							</AuthWrapper>
						</div>
					)}
				</div>
			</div>
		</ErrorBoundary>
	);
};

export default App;
